/*
https://iwb.jp/s/html-forms-password-input-field-eye-button-show-or-hide/
*/
/*
const passwordToggle = document.querySelector('.password__toggle')

passwordToggle.addEventListener('click', (e) => {
  const input = e.target.previousElementSibling
  const type = input.getAttribute('type')
  input.setAttribute('type', type === 'password' ? 'text' : 'password')
  passwordToggle.classList.toggle('is-visible')
});
*/


/**
  https://qiita.com/meowave/items/465fcb91a9fd06c4a8b3
 */
//  id="view"を取得
let viewicon = document.getElementById('view');

//  id="password"を取得
let inputtype = document.getElementById('password');

//  id="view"クリック時の処理を設定
jQuery('#view').on('click', function () {

       //  passwordからtextへ
      if(inputtype.type === 'password'){
              inputtype.type = 'text';
//              viewicon.innerHTML = '<i class="far fa-eye"></i>';
              viewicon.innerHTML = '<img src="./images/common/eye_01.png" alt="">';

        //  textからpasswordへ
        } else {
              inputtype.type = 'password';
//              viewicon.innerHTML = '<i class="far fa-eye-slash"></i>';
              viewicon.innerHTML = '<img src="./images/common/eye_02.png" alt="">';
        }
});
